module.exports = __webpack_public_path__ + "248e9416c123c5e6da5fa1b86957b46a.pdf";